// Libs
import React, { Component } from 'react'
import { Container } from '../../components/Elemental'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import _ from 'lodash'

// CSS
import './styles.scss'

// Containers/Components
import Search from '../Search'
import Notify from '../Notify'
import Swap from '../Swap'
import SwapCase from '../SwapCase'
import HeaderHamburguerIcon from './components/HeaderHamburguerIcon'
import HeaderLink from './components/HeaderLink'
import HeaderMobile from './components/HeaderMobile'
import HeaderPopUp from './components/HeaderPopUp'
import LogoIcon from '../../components/LogoIcon'
import ProfileIcon from '../../components/ProfileIcon'

// Actions
import { changeHeaderVisible } from './actions'
import { signOut } from '../Deauth/actions'

class Header extends Component {
  render() {
    const { user: { id, role, image, name, surname, group, lawFirm, admin, token, capture }, visible, notifications, changeHeaderVisible, signOut } = this.props
    const full_name = `${name} ${surname}`

    return (
      <div>
        <div className="header">
          <Container gutter={0} className="header__container">
            <div className="header__left">
              <NavLink
                to={role === 'lawyer' ? '/meus-casos' : '/dashboard'}
                className="header__logo">
                <LogoIcon height={32} />
              </NavLink>
              {role === 'company' &&
                <HeaderLink to="/dashboard">Dashboard</HeaderLink>
              }
              {(role === 'company' && capture) ?
                <HeaderLink to="/captacao" border="right">Captação</HeaderLink>
                :
                ''
              }
              {role === 'company' &&
                <HeaderLink to="/inserir-caso-contencioso">Inserir Caso</HeaderLink>
              }
              {role === 'company' && admin &&
                <HeaderLink to="/importador/contatos">Inserir Contato</HeaderLink>
              }
              <HeaderLink to="/meus-casos">
                Meus Casos
              </HeaderLink>
            </div>
            <div className="header__right">
              <Swap />
              <SwapCase />
              {role === 'company' &&
                <Search />
              }
              <Notify />
              <HeaderLink to="/perfil">
                <ProfileIcon
                  image={image + '/medium'}
                  lawyerName={role === 'lawyer' ? full_name : null}
                  companyName={role === 'company' ? full_name : null} />
                <div className="header__profile">
                  <p>{name} {surname ? surname.toUpperCase().charAt(0) : ''}.</p>
                  <p>{lawFirm ? lawFirm : group}</p>
                </div>
              </HeaderLink>
              <HeaderHamburguerIcon
                visible={visible.status && visible.type === 'mobile'}
                onClick={() => changeHeaderVisible('mobile')} />
              <HeaderLink to="/login" onClick={signOut}>Sair</HeaderLink>
            </div>
          </Container>
        </div>
        <HeaderMobile
          visible={visible.status && visible.type === 'mobile'}
          role={role}
          name={name}
          surname={surname}
          image={image}
          group={group}
          lawFirm={lawFirm}
          admin={admin}
          notifications={notifications}
          onClick={() => changeHeaderVisible('')}
          onLogout={signOut}
          capture={capture} />
      </div>
    )
  }
}

Header = connect(state => {
  return {
    user: state.auth.user,
    visible: state.header.visible,
    notifications: state.notify.notifications
  }
}, { changeHeaderVisible, signOut })(Header)

export default Header
